<template>
	<LayoutBase>
		<div v-if="suspendSuccess" class="alert alert--success">User has been suspended</div>
		<div v-if="unsuspendSuccess" class="alert alert--success">User has been unsuspended</div>
		<header id="content__header">
			<template v-if="currentUser">
				<h1>My Account</h1>

				<button @click.prevent="logout" class="btn">Logout</button>
				<router-link :to="{ name: 'view-user', params: { user_id: user.id } }" class="btn btn--primary">
					View Profile
				</router-link>
			</template>

			<template v-else>
				<h1>Edit User</h1>

				<button v-if="suspended" class="btn btn--danger" @click.prevent="showUnsuspendModal">
					Unsuspend user
				</button>
				<button v-else class="btn btn--danger" @click.prevent="showSuspendModal">Suspend user</button>
				<router-link :to="{ name: 'view-user', params: { user_id: id } }" class="btn btn--primary">
					View Profile
				</router-link>
				<button class="btn" v-if="savedFormData.can && savedFormData.can.delete">Delete User</button>
			</template>
		</header>

		<vue-tabs ref="tabs" @tab-change="onTabChange">
			<v-tab id="profile" title="Personal Information">
				<UserFormProfile :currentUser="currentUser"></UserFormProfile>
			</v-tab>
			<v-tab id="password" title="Change Password">
				<UserFormPassword :currentUser="currentUser"></UserFormPassword>
			</v-tab>
			<v-tab id="following" title="Sectors you follow">
				<UserFormFollowedSectors :currentUser="currentUser"></UserFormFollowedSectors>
			</v-tab>
			<v-tab id="expertise" title="Sector Expertise">
				<UserFormSpecialisedSectors :currentUser="currentUser"></UserFormSpecialisedSectors>
			</v-tab>
		</vue-tabs>
	</LayoutBase>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import LayoutBase from '../Layout/LayoutBase';
	import UserFormProfile from './Form/UserFormProfile';
	import UserFormPassword from './Form/UserFormPassword';
	import UserFormFollowedSectors from './Form/UserFormSubscribedSectors';
	import UserFormSpecialisedSectors from './Form/UserFormSpecialisedSectors';
	import TabbedPage from '../TabbedPage';
	import Form from '../Form/Form';
	import API from './../../api';

	export default {
		name: 'UserForm',
		mixins: [Form, TabbedPage],
		components: {
			UserFormSpecialisedSectors,
			UserFormFollowedSectors,
			UserFormPassword,
			UserFormProfile,
			LayoutBase
		},
		props: {
			id: {
				type: Number,
				default: null,
			}
		},
		data() {
			return {
				defaultTab: 'profile',
				tabRoute: this.id ? 'edit-user' : 'account',
				tabParams: {
					id: this.id,
				},
				currentUser: !this.id,
				suspendSuccess: false,
				unsuspendSuccess: false,
                suspended: false,
			}
		},
		computed: {
			...mapState({
				user: state => state.auth.user,
			}),
			...mapGetters({
				savedFormData: 'form/formData'
			})
		},
		methods: {
			loadResource() {
				let promise;
				this.$store.commit('form/clear');

				if(this.currentUser) {
					promise = Promise.resolve(JSON.parse(JSON.stringify(this.user)));
				} else {
					promise = this.fetchResource(this.id);
				}

				promise.then(response => {
                    const sanitizedResponse =  this.sanitizeResource(response);
					this.$store.commit('form/setId', response.id);
					this.$store.commit('form/mergeFormData', sanitizedResponse);
					this.suspended = response.suspended;
				}).catch(error => console.error(error));
			},
			fetchResource(id) {
				return API.getUser(id);
			},
			sanitizeResource(response) {
				if(response.avatar) {
					this.$store.commit('selectCache/addAttachment', response.avatar);
				}

				if(response.office) {
					this.$store.commit('selectCache/addOffice', response.office);
				}


				response.avatar = response.avatar ? (response.avatar.uuid ?? null) : null;
				response.member = response.member ? (response.member.id ?? null) : null;
				response.office = response.office ? (response.office.id ?? null) : null;

				response.subscribed = response.subscribed.map(sector => sector.id);
				response.specialisms = response.specialisms.map(sector => sector.id);

				return response;
			},
			logout() {
				this.$store.dispatch('logout');
				window.location.reload(true);
			},
			showSuspendModal() {
				this.$modal.show('dialog', {
					title:'Are you sure you want to suspend this user?',
					text: 'This user will lose access to MAIS',
					buttons: [
						{
							class: 'btn btn--danger',
							title: 'Suspend user',
							handler: () => {
								this.unsuspendSuccess = false;
								this.suspendSuccess = false;

								API.suspendUser(this.id).then(response => {
									this.suspendSuccess = true;
									this.$store.commit('form/mergeFormData', response.data.data);
								});

								this.$modal.hide('dialog');
							}
						},
					]
				});
			},
			showUnsuspendModal() {
				this.$modal.show('dialog', {
					title:'Are you sure you want to unsuspend this user?',
					text: 'This user will regain access to MAIS',
					buttons: [
						{
							class: 'btn btn--danger',
							title: 'Unsuspend user',
							handler: () => {
								this.suspendSuccess = false;
								this.unsuspendSuccess = false;

								API.unsuspendUser(this.id).then(response => {
									this.unsuspendSuccess = true;
									this.$store.commit('form/mergeFormData', response.data.data);
								});

								this.$modal.hide('dialog');
							}
						},
					]
				});
			}
		}
	}
</script>

